<template>
    <Wrapper>
        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12 lg:col-span-7">
                <h1 class="header-1 mb-4"><T t="customer_service.title" /></h1>
                <CustomerServiceHubspotForm />
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import CustomerServiceHubspotForm from '@/components/Forms/CustomerServiceHubspotForm.vue';

export default {
    name: 'CustomerService',
    components: {
        Wrapper,
        CustomerServiceHubspotForm,
    },
    asyncData({ i18n }) {
        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('customer_service.title'), 'customer-service']);

        return {
            breadcrumbItems,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('customer-service.index'),
            meta: this.$getPageMetaData('customer-service.index'),
        };
    },
};
</script>

<style></style>
